// extracted by mini-css-extract-plugin
export default {"Title":"LiveStreamInfo_Title__hlc6o"};